<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Group</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="add">
            <i class="fa fa-plus"></i>New Group
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <form id="saveForm" @submit.prevent="save"></form>
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center action-column">Action</th>
                <th class="group-column">
                  <button class="btn p-0" @click="setSortBy('groupName')">
                    Group
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'groupName'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'groupName_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('remarks')">
                    Remarks
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'remarks'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'remarks_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="showAddMode" class="table-info">
                <td class="action-column">
                  <button
                    type="submit"
                    class="btn"
                    title="Save"
                    form="saveForm"
                  >
                    <i class="fa fa-save"></i>
                  </button>
                  <button
                    type="button"
                    class="btn"
                    title="Cancel"
                    @click="cancel"
                  >
                    <i class="fa fa-window-close-o"></i>
                  </button>
                </td>
                <td class="group-column">
                  <input
                    type="text"
                    class="form-control"
                    v-model="formData.groupName"
                    maxlength="1"
                    form="saveForm"
                    required
                  />
                </td>
                <td>
                  <textarea
                    v-model="formData.remarks"
                    class="form-control"
                    form="saveForm"
                  ></textarea>
                </td>
              </tr>
              <tr
                v-for="item in groups"
                :key="item.Id"
                :class="!item.IsActive ? 'disabled-color' : ''"
              >
                <template v-if="formData.id !== item.Id">
                  <td class="action-column">
                    <label class="toggler">
                      <input
                        type="checkbox"
                        v-model="item.IsActive"
                        @change="toggle(item, $event)"
                      />
                      <span class="slider round"></span>
                    </label>
                    <button
                      v-if="item.IsActive"
                      class="btn mt-2"
                      title="Edit"
                      @click="edit(item)"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      v-if="item.IsActive"
                      class="btn mt-2"
                      title="Delete"
                      @click="remove(item.Id)"
                    >
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                  <td class="group-column">{{ item.GroupName }}</td>
                  <td>{{ item.Remarks }}</td>
                </template>
                <template v-else>
                  <td class="action-column table-info">
                    <button
                      type="submit"
                      class="btn"
                      title="Save"
                      form="saveForm"
                    >
                      <i class="fa fa-save"></i>
                    </button>
                    <button
                      type="button"
                      class="btn"
                      title="Cancel"
                      @click="cancel"
                    >
                      <i class="fa fa-window-close-o"></i>
                    </button>
                  </td>
                  <td class="group-column table-info">
                    <input
                      type="text"
                      class="form-control"
                      v-model="formData.groupName"
                      maxlength="1"
                      form="saveForm"
                      required
                    />
                  </td>
                  <td class="table-info">
                    <textarea
                      v-model="formData.remarks"
                      class="form-control"
                      form="saveForm"
                    ></textarea>
                  </td>
                </template>
              </tr>
              <tr v-if="groups && !groups.length">
                <td colspan="3" class="text-center">{{ this.noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      groups: null,
      showAddMode: false,
      noRecordText: config.NO_RECORD_TEXT,
      formData: {
        id: "",
        groupName: "",
        remarks: "",
      },
      //for pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getGroups() {
      let param = {
        Token: this.token,
        SortBy: this.paging.SortBy,
      };
      this.$store.state.isLoading = true;
      API.getGroup(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.groups = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //action
    resetForm() {
      this.formData = {
        id: "",
        groupName: "",
        remarks: "",
      };
    },
    add() {
      this.showAddMode = true;
      this.resetForm();
    },
    edit(payload) {
      this.showAddMode = false;
      this.resetForm();
      this.formData.id = payload.Id;
      this.formData.groupName = payload.GroupName;
      this.formData.remarks = payload.Remarks;
    },
    cancel() {
      this.showAddMode = false;
      this.resetForm();
      this.getGroups();
    },
    remove(id) {
      let param = {
        Token: this.token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteGroup(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    save() {
      let param = {
        Token: this.token,
        Id: this.formData.id,
        GroupName: this.formData.groupName,
        Remarks: this.formData.remarks,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveGroup(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },

    toggle(payload, $event) {
      let isActive = $event.target.checked;
      let param = {
        Token: this.token,
        Id: payload.Id,
        IsActive: isActive,
      };
      this.$store.state.isLoading = true;
      API.toggleGroup(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.cancel();
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //pagination
    setSortBy(payload) {
      switch (payload) {
        case "groupName":
          if (this.paging.SortBy === "groupName") {
            this.paging.SortBy = "groupName_desc";
          } else if (this.paging.SortBy === "groupName_desc") {
            this.paging.SortBy = "groupName";
          } else {
            this.paging.SortBy = "groupName";
          }
          break;
        case "remarks":
          if (this.paging.SortBy === "remarks") {
            this.paging.SortBy = "remarks_desc";
          } else if (this.paging.SortBy === "remarks_desc") {
            this.paging.SortBy = "remarks";
          } else {
            this.paging.SortBy = "remarks";
          }
          break;
      }
      this.getGroups();
    },
  },

  created() {
    if (this.role != "admin")
      this.$router.replace({ name: "home" });
    else this.getGroups();
  },
};
</script>

<style scoped>
.group-column {
  width: 12%;
}
</style>


// WEBPACK FOOTER //
// src/components/Benefit/Group.vue